import React from 'react';
import classNames from 'classnames';
import moment from 'moment';
import { OverlayTrigger } from 'react-bootstrap';
import { useBreakpoint } from 'hooks';
import formatStatus from '../../../helpers/formatStatus';

const Step3TimeList = ({
  customDuration,
  isAdmin,
  isListingAgent,
  isTeamAdmin,
  showCaptcha,
  appointment,
  appointmentTimes,
  time,
  availableTimes = {},
  appointmentsInfo,
  duration,
  openHouses,
  offerDate,
  offerAnytime,
  selectedTimes = {},
  openHouseTimes,
  hiddenTimes,
  timePassed,
  maxDuration = 60,
  PopoverComponent,
  // functions
  expandTime,
  selectTime,
}) => {
  const customDurationRestricted = () => {
    if (!customDuration.enabled) return false;
    const totalCustomDuration =
      customDuration.durationHour * 60 + customDuration.durationMinutes;
    return totalCustomDuration > maxDuration;
  };
  const NonAdminClassName = classNames({
    timeslot: true,
    'timeslot-unavailable':
      availableTimes && !availableTimes[time.format('h:mm A')],
    'timeslot-selected': selectedTimes && selectedTimes[time.format('h:mm A')],
    'timeslot-appointment':
      appointmentTimes && appointmentTimes[time.format('h:mm A')],
    'timeslot-passed': timePassed(time),
  });

  const AdminClassName = classNames({
    timeslot: true,
    'timeslot-unavailable':
      appointment &&
      !appointment.recordAppointment &&
      availableTimes &&
      !availableTimes[time.format('h:mm A')],
    'timeslot-passed': timePassed(time),
    'timeslot-selected':
      (selectedTimes?.[time.format('h:mm A')] &&
        !customDuration.enabled &&
        duration <= maxDuration) ||
      (selectedTimes?.[time.format('h:mm A')] &&
        customDuration.enabled &&
        !customDurationRestricted()),
    'timeslot-selectedRestricted':
      (selectedTimes?.[time.format('h:mm A')] &&
        !customDuration.enabled &&
        duration > maxDuration) ||
      (selectedTimes?.[time.format('h:mm A')] &&
        customDuration.enabled &&
        customDurationRestricted()),
    'timeslot-appointment':
      appointmentTimes && appointmentTimes[time.format('h:mm A')],
    'timeslot-openhouse':
      openHouseTimes && openHouseTimes[time.format('h:mm A')],
    'timeslot-offerdate': time.isSame(offerDate, 'minute') && !offerAnytime,
    'timeslot-hidden':
      hiddenTimes && hiddenTimes[time.format('h:mm A')] && !appointment.time,
  });

  const { md } = useBreakpoint();
  return (
    <div>
      {!isAdmin &&
        !isListingAgent &&
        !isTeamAdmin &&
        ((availableTimes && !availableTimes[time.format('h:mm A')]) ||
          timePassed(time)) && (
          <div
            style={{ cursor: 'default' }}
            id={`timeWidget-${time.format('h:mm A')}`}
            className={NonAdminClassName}
          >
            <span
              className={
                appointment && appointment.time === time
                  ? 'invisible'
                  : 'visible'
              }
            >
              {time.format('h:mm A')}
            </span>
            {appointment && appointment.time === time && (
              <span
                className={
                  customDuration.enabled
                    ? (customDuration.durationMinutes ||
                        customDuration.durationHour) &&
                      'timeslot-time'
                    : Object.keys(selectedTimes).length && 'timeslot-time'
                }
              >
                {time.format('h:mm A')} - {appointment.timeEnd.format('h:mm A')}
                v
              </span>
            )}
          </div>
        )}
      {(isAdmin ||
        isListingAgent ||
        isTeamAdmin ||
        (availableTimes[time.format('h:mm A')] && !timePassed(time))) && (
        <OverlayTrigger
          trigger={md && 'click'}
          placement="left"
          overlay={PopoverComponent}
          rootClose
        >
          <div
            onClick={() => !showCaptcha && selectTime(time)}
            style={{
              minHeight:
                appointment &&
                !appointment.time &&
                appointmentsInfo &&
                appointmentsInfo[time.format('h:mm A')] &&
                appointmentsInfo[time.format('h:mm A')].expand &&
                appointmentsInfo[time.format('h:mm A')].expand['min-height'],
            }}
            id={`timeWidget-${time.format('h:mm A')}`}
            className={AdminClassName}
            data-cy="select-time"
          >
            {appointment && appointment.time !== time && (
              <span>
                {((appointmentsInfo &&
                  (!appointmentsInfo[time.format('h:mm A')] ||
                    !appointmentsInfo[time.format('h:mm A')].expand)) ||
                  appointment.time) && (
                  <span>
                    {time.format('h:mm A')}
                    {openHouses &&
                      openHouses[time.format('h:mm A')] &&
                      selectedTimes &&
                      !selectedTimes[time.format('h:mm A')] && (
                        <span className="timeslot-label">Open House</span>
                      )}
                    {time.isSame(offerDate) &&
                      !offerAnytime &&
                      selectedTimes &&
                      !selectedTimes[time.format('h:mm A')] && (
                        <span className="timeslot-label">Offer Pres</span>
                      )}
                    {appointmentsInfo &&
                      appointmentsInfo[time.format('h:mm A')] &&
                      appointmentsInfo[time.format('h:mm A')].appointments
                        .length > 0 &&
                      selectedTimes &&
                      (selectedTimes === null ||
                        !selectedTimes[time.format('h:mm A')]) && (
                        <span
                          className="appointment-count"
                          onClick={e =>
                            expandTime(e, time.format('h:mm A'), true)
                          }
                        >
                          {
                            appointmentsInfo[time.format('h:mm A')].appointments
                              .length
                          }
                        </span>
                      )}
                  </span>
                )}
                {appointmentsInfo &&
                  appointmentsInfo[time.format('h:mm A')] &&
                  appointmentsInfo[time.format('h:mm A')].expand &&
                  !appointment.time && (
                    <span>
                      {time.format('h:mm A')} -{' '}
                      {appointmentsInfo[
                        time.format('h:mm A')
                      ].maxTimeEnd.format('h:mm A')}
                      {appointmentsInfo[time.format('h:mm A')].appointments.map(
                        apt => (
                          <p
                            key={apt.confirmationId}
                            className="timeslot-details"
                          >
                            {apt.coop.name}
                            <br />
                            {apt.coop && apt.coop.org && apt.coop.org.name}
                            <br />
                            {formatStatus(apt.status)}
                          </p>
                        ),
                      )}
                      <span
                        className="appointment-count fa fa-close"
                        onClick={e =>
                          expandTime(e, time.format('h:mm A'), false)
                        }
                      ></span>
                    </span>
                  )}
              </span>
            )}
            {appointment && appointment.time === time && (
              <span
                className={
                  customDuration.enabled
                    ? (customDuration.durationMinutes ||
                        customDuration.durationHour) &&
                      'timeslot-time'
                    : Object.keys(selectedTimes).length && 'timeslot-time'
                }
              >
                {time.format('h:mm A')}
                {customDuration.enabled &&
                customDuration.durationHour === 0 &&
                customDuration.durationMinutes === 0 ? (
                  ''
                ) : (
                  <>
                    {' '}
                    -{' '}
                    {appointment &&
                      appointment.timeEnd &&
                      moment(appointment.timeEnd).format('h:mm A')}
                  </>
                )}
              </span>
            )}
          </div>
        </OverlayTrigger>
      )}
    </div>
  );
};

export default Step3TimeList;
